import Vue from 'vue'
import axios from 'axios'

const initState = {
  accounts: [],
  accountsObject: {}
}

export default {
  namespaced: true,
  state: Vue.util.extend({}, initState),
  mutations: {
    SET_ACCOUNTS(state, accounts) {
      state.accounts = accounts
      const object = {}
      accounts.forEach((account) => {
        object[`account-${account.id}`] = account
      })
      state.accountsObject = object
    },
    UPDATE_ACCOUNT(state, singleAccount) {
      const accounts = state.accounts
      const accountsObject = state.accountsObject
      if (!accountsObject[`account-${singleAccount.id}`]) {
        accounts.push(singleAccount)
      } else {
        let indexFound = -1
        accounts.every((item, index) => {
          if (item.id === singleAccount.id) {
            indexFound = index
            return false
          }
          return true
        })
        if (indexFound >= 0) {
          accounts.splice(indexFound, 1, singleAccount)
        }
      }
      accountsObject[`account-${singleAccount.id}`] = singleAccount
      state.accounts = accounts
      state.accountsObject = accountsObject
    },
    DELETE_ACCOUNT(state, singleAccountId) {
      const accounts = state.accounts
      const accountsObject = state.accountsObject
      if (accountsObject[`account-${singleAccountId}`]) {
        delete accountsObject[`account-${singleAccountId}`]
        let indexFound = -1
        accounts.every((item, index) => {
          if (item.id === singleAccountId) {
            indexFound = index
            return false
          }
          return true
        })
        if (indexFound >= 0) {
          accounts.splice(indexFound, 1)
        }
      }
      state.accounts = accounts
      state.accountsObject = accountsObject
    }
  },
  actions: {
    getAllAccounts({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/gateways/all`)
          .then((res) => {
            commit('SET_ACCOUNTS', res.data.accounts)
            resolve(res.data.accounts)
          })
          .catch((error) => reject(error))
      })
    },
    getActiveStripeAccount({ commit }, landingId) {
      return new Promise((resolve, reject) => {
        axios
          .get(`/landings/${landingId}/gateways/stripe/active`)
          .then((res) => resolve(res.data.activeAccount))
          .catch((error) => reject(error))
      })
    },
    checkValidity({ commit }, { landingId, platform }) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${landingId}/gateways/${platform}/check`)
          .then(() => resolve(true))
          .catch((error) => reject(error))
      })
    },
    checkStripeAccountRequest({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/stripe-accounts/verify`, params)
          .then((res) => resolve(res.data))
          .catch((error) => reject(error))
      })
    },
    createStripeAccount({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .post(`/landings/${params.landing_id}/gateways/stripe`, params)
          .then((res) => resolve(res.data.account))
          .catch((error) => reject(error))
      })
    },
    updateStripeAccount({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landing_id}/gateways/stripe/${params.id}`, params)
          .then((res) => {
            commit('UPDATE_ACCOUNT', res.data.account)
            resolve(res.data.account)
          })
          .catch((error) => reject(error))
      })
    },
    revokeStripeAccount({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .put(`/landings/${params.landing_id}/gateways/stripe/${params.id}/revoke`)
          .then((res) => {
            commit('UPDATE_ACCOUNT', res.data.account)
            resolve(res.data.account)
          })
          .catch((error) => reject(error))
      })
    },
    destroyAccount({ commit }, params) {
      return new Promise((resolve, reject) => {
        axios
          .delete(`/landings/${params.landing_id}/gateways/${params.platform}/${params.id}`)
          .then(() => {
            commit('DELETE_ACCOUNT', params.id)
            resolve(true)
          })
          .catch((error) => reject(error))
      })
    }
  },
  getters: {
    accounts(state) { return state.accounts }
  }
}